import { reducerWithInitialState } from "typescript-fsa-reducers";

export interface ConfigState {
  enableCreditLens: boolean;
  enableFlyoutReasons: boolean;
  baseApiUrl: string;
  ssoBaseApiUrl: string;
  ssoRedirectUrl: string;
  ssoSignoutUrl: string;
  ssoCredentials: string;
  creditLensPathPrefix: string;
  localAuthPath: string;
  documentsPollIntervalMs: number;
  unmappedAccountsEnabled: boolean;
  dbsJwtLoginEnabled: boolean;
  dbsUploadButtonEnabled: boolean;
  pageSize: number;
  env: string;
}

export const initialState: ConfigState = {
  baseApiUrl: "",
  ssoBaseApiUrl: "",
  ssoRedirectUrl: "",
  ssoSignoutUrl: "",
  ssoCredentials: "",
  creditLensPathPrefix: "",
  enableCreditLens: false,
  enableFlyoutReasons: false,
  localAuthPath: "",
  documentsPollIntervalMs: 10_000,
  unmappedAccountsEnabled: false,
  dbsJwtLoginEnabled: false,
  dbsUploadButtonEnabled: false,
  pageSize: 25,
  env: ""
};

const configReducer = reducerWithInitialState<Readonly<ConfigState>>(
  initialState
);

export default configReducer;



// WEBPACK FOOTER //
// ./src/configState/reducer.ts